export default __webpack_public_path__ + "static/media/slot24.d304524f.png";